<template>
  <slot></slot>
  <div class="grid grid-cols-1 gap-y-4 sm:grid-cols-12">
    <!-- Searchable Category Select -->
    <div class="form-group col-span-12" ref="selectWrapperRef">
      <label for="maloai-search" class="block text-sm font-medium text-black mb-2">
        Chọn danh mục <span v-show="!maloai" class="error">*</span>
      </label>

      <!-- Hidden real input for form submission -->
      <input type="hidden" name="maloai" :value="maloai" />

      <!-- Trigger -->
      <div
        class="relative w-full select-none cursor-pointer"
        @click="toggleSelect"
      >
        <div
          class="flex items-center justify-between px-3 py-2 min-h-[40px] bg-black text-white border rounded transition-all duration-200"
          :class="isSelectOpen ? 'border-indigo-500 ring-2 ring-indigo-500/30' : 'border-gray-600'"
        >
          <span :class="!selectedCategoryName ? 'text-gray-400' : 'text-white'">
            {{ selectedCategoryName || 'Chọn danh mục' }}
          </span>
          <span
            class="text-gray-400 text-sm transition-transform duration-200 inline-block"
            :class="{ 'rotate-180': isSelectOpen }"
          >▾</span>
        </div>

        <!-- Dropdown Panel -->
        <div
          v-show="isSelectOpen"
          class="absolute top-[calc(100%+4px)] left-0 right-0 bg-gray-900 border border-gray-600 rounded-lg shadow-2xl z-[9999] overflow-hidden"
          @click.stop
        >
          <!-- Search -->
          <div class="flex items-center gap-2 px-3 py-2 bg-gray-950 border-b border-gray-700">
            <span class="text-xs flex-shrink-0">🔍</span>
            <input
              id="maloai-search"
              v-model="categorySearch"
              type="text"
              placeholder="Tìm danh mục..."
              class="flex-1 !bg-transparent !border-none !outline-none !text-white !shadow-none text-sm !ring-0"
              style="color: #ffffff !important; background: transparent !important; border: none !important; box-shadow: none !important;"
              @click.stop
              ref="searchInputRef"
            />
            <button
              v-show="categorySearch"
              type="button"
              class="text-gray-400 hover:text-white text-xs leading-none px-0.5 bg-transparent border-none cursor-pointer"
              @click.stop="categorySearch = ''"
            >✕</button>
          </div>

          <!-- Sort indicator -->
          <div class="flex justify-between items-center px-3 py-1 bg-gray-950 border-b border-gray-700 text-[11px] text-gray-500">
            <span>📋 Sắp xếp A → Z</span>
            <span class="bg-gray-700 text-gray-400 rounded-full px-2 py-0.5 text-[10px]">{{ filteredCategories.length }} danh mục</span>
          </div>

          <!-- Options -->
          <ul class="list-none m-0 py-1 max-h-52 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600">
            <li
              v-if="filteredCategories.length === 0"
              class="px-3 py-3 text-center text-gray-500 text-sm italic"
            >
              Không tìm thấy danh mục
            </li>
            <li
              v-for="category in filteredCategories"
              :key="category.id"
              class="flex items-center gap-2 px-3 py-2 cursor-pointer text-sm transition-colors duration-150"
              :class="maloai === category.id
                ? 'bg-indigo-900 text-indigo-300 font-medium'
                : 'text-gray-200 hover:bg-gray-700'"
              @click.stop="selectCategory(category)"
            >
              <span class="text-indigo-400 text-xs w-3.5 flex-shrink-0">
                <span v-show="maloai === category.id">✓</span>
              </span>
              <span>{{ category.ten_loai }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="form-group col-span-12">
      <label for="ProductName" class="block text-sm font-medium text-black mb-2"
        >Tên sản phẩm <span v-show="!tensp" class="error">*</span></label
      >
      <input
        v-model="tensp"
        type="text"
        name="productTitle"
        id="ProductName"
        autocomplete="off"
        class="text-white bg-black w-full"
        placeholder="Tên sản phẩm"
        required
      />
    </div>
    <div class="form-group col-span-12 sm:col-span-6">
      <label
        for="ProductImages"
        class="block text-sm font-medium text-black mb-2"
        >Hình ảnh <span v-show="!ProductImages" class="error">*</span></label
      >
      <FilePond
        aria-required="true"
        name="ProductImages"
        id="ProductImages"
        v-model="ProductImages"
        server="/api/images"
        ref="pond"
        label-idle="Drop files here..."
        accept="image/*"
      >
      </FilePond>
    </div>
    <div class="form-group col-span-12">
      <MultiImages />
    </div>

    <div
      class="form-group col-span-12"
      v-for="(account, index) in accounts"
      :key="index"
    >
      <label
        :for="'tkgame-' + index"
        class="block text-sm font-medium text-black mb-2"
        >Tài khoản {{ index + 1 }}
        <span v-show="!account.tkgame" class="error">*</span></label
      >
      <input
        v-model="account.tkgame"
        type="text"
        :name="'accounts[' + index + '][tkgame]'"
        :id="'tkgame-' + index"
        class="text-white bg-black w-full"
        placeholder="Tài khoản account"
        required
      />

      <label
        :for="'mkgame-' + index"
        class="block text-sm font-medium text-black mb-2"
        >Mật khẩu {{ index + 1 }}
        <span v-show="!account.mkgame" class="error">*</span></label
      >
      <input
        v-model="account.mkgame"
        type="text"
        :name="'accounts[' + index + '][mkgame]'"
        :id="'mkgame-' + index"
        class="text-white bg-black w-full"
        placeholder="Mật khẩu account"
        required
      />

      <label
        :for="'giasp-' + index"
        class="block text-sm font-medium text-black mb-2"
        >Giá account {{ index + 1 }}
        <span v-show="!account.giasp" class="error">*</span></label
      >
      <input
        v-model="account.giasp"
        type="number"
        :name="'accounts[' + index + '][giasp]'"
        :id="'giasp-' + index"
        class="text-white bg-black w-full"
        placeholder="Giá account"
        
        required
      />

      <label
        :for="'type-' + index"
        class="block text-sm font-medium text-black mb-2"
        >Loại account {{ index + 1 }}</label
      >
      <input
        v-model="account.type"
        type="text"
        :name="'accounts[' + index + '][type]'"
        :id="'type-' + index"
        class="text-white bg-black w-full"
        placeholder="Loại account (vd: 50k, 60k)"
      />

      <button
        type="button"
        class="btn btn-outline-danger"
        @click="removeAccount(index)"
        v-show="accounts.length > 1"
      >
        <span class="fa-solid fa-trash"></span> Xóa acc
      </button>
    </div>
    <!-- End dynamic input -->
    <div class="form-group col-span-12">
      <label for="notes" class="block text-sm font-medium text-black mb-2"
        >Lưu ý</label
      >
      <input
        type="text"
        name="notes"
        id="notes"
        class="text-white bg-black w-full"
        placeholder="lưu ý sản phẩm"
      />
    </div>
    <div class="form-group col-span-12">
      <label for="desription" class="block text-sm font-medium text-black mb-2"
        >Mô tả <span v-show="!mota" class="error">*</span></label
      >
      <!--  <textarea
        v-model="mota"
        name="desription"
        id="desription"
        rows="3"
        class="w-full text-black bg-black"
        placeholder="Mô tả"
        required
      ></textarea> -->
      <RichEditor name="desription" title="Mô tả " />
    </div>
    <div class="flex w-full gap-4 col-span-8">
      <button
        type="submit"
        @click="CheckListImg('Frmadd')"
        class="p-3 bg-green-300 text-black"
        name="themsp"
        id="submit-btn"
      >
        <span class="fa-solid fa-file-arrow-down"></span> Thêm
      </button>
      <!-- Add button "Add" to duplicate inputs -->
      <button
        type="button"
        class="p-3 bg-green-300 text-black"
        @click="addAccount"
      >
        <span class="fa-solid fa-plus"></span> Thêm acc
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue'
import route from 'ziggy-js'

const props = defineProps(['title', 'categories'])
const isShowModal = ref(false)

const maloai = ref('')
const tensp = ref('')
const ProductImages = ref(null)
const images = ref(null)
const accounts = ref([{ tkgame: '', mkgame: '', giasp: '', type: '' }])
const mota = ref('')

// ---- Searchable Category Select ----
const isSelectOpen = ref(false)
const categorySearch = ref('')
const selectWrapperRef = ref(null)
const searchInputRef = ref(null)

// Danh mục sắp xếp A-Z và lọc theo search
const filteredCategories = computed(() => {
  const list = props.categories ? [...props.categories] : []
  // Sắp xếp A-Z theo ten_loai
  list.sort((a, b) =>
    a.ten_loai.localeCompare(b.ten_loai, 'vi', { sensitivity: 'base' })
  )
  // Lọc theo từ khóa search
  const q = categorySearch.value.trim().toLowerCase()
  if (!q) return list
  return list.filter(c => c.ten_loai.toLowerCase().includes(q))
})

// Tên danh mục đang được chọn
const selectedCategoryName = computed(() => {
  if (!maloai.value || !props.categories) return ''
  const found = props.categories.find(c => c.id === maloai.value)
  return found ? found.ten_loai : ''
})

const toggleSelect = () => {
  isSelectOpen.value = !isSelectOpen.value
  if (isSelectOpen.value) {
    nextTick(() => {
      searchInputRef.value?.focus()
    })
  }
}

const selectCategory = (category) => {
  maloai.value = category.id
  isSelectOpen.value = false
  categorySearch.value = ''
}

// Click outside để đóng dropdown
const handleClickOutside = (event) => {
  if (selectWrapperRef.value && !selectWrapperRef.value.contains(event.target)) {
    isSelectOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
// ---- End Searchable Category Select ----

const addAccount = () => {
  const lastAccount = accounts.value[accounts.value.length - 1];
  accounts.value.push({
    tkgame: '',
    mkgame: '',
    giasp: lastAccount ? lastAccount.giasp : '',
    type: lastAccount ? lastAccount.type : '',
  });
}

const removeAccount = (index) => {
  accounts.value.splice(index, 1)
}

const openModal = () => {
  isShowModal.value = true
}

const closeModal = () => {
  isShowModal.value = false
}
</script>
<style>
.error {
  color: red;
}
</style>

<script>
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import MultiImages from './MultiImages.vue'
import RichEditor from '../../../components/RichEditor.vue'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)
</script>

<style scoped>
@import 'filepond/dist/filepond.min.css';
@import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
</style>
